const isFunction = (x: unknown): x is (() => any) => typeof x === 'function'

export function resolveValue<V> (value: V | (() => V) | undefined): V | undefined {
  return isFunction(value) ? value() : value
}
